/* @flow */

import React from 'react';
import { Form } from 'semantic-ui-react';

type Props = {
  templates: Array<CatalogTemplate>,
  input: Object,
  meta: Object,
  label: String,
};

const templateValues = templates =>
  templates.map(t => ({
    value: t.code,
    text: t.label,
  }));

const TemplateSelector = ({
  templates,
  input,
  meta: { touched, error },
  label,
}: Props) => {
  const templateChanged = (_, { value }) => input.onChange(value);

  return (
    <Form.Select
      {...input}
      error={touched && !!error}
      label={label}
      onChange={templateChanged}
      options={templateValues(templates)}
      placeholder="Sélectionnez un type"
    />
  );
};

export default TemplateSelector;



// WEBPACK FOOTER //
// ./src/modules/catalog/screens/shared/components/TemplateSelector.js